module.exports = __webpack_public_path__ + "static/soren-d6c716897d7e9b940b1363dd69465bd3.gif";